import React from 'react';

export default function BrutalistButton({ onClick, children, variant = 'primary' }) {
  const baseStyle = "px-6 py-3 text-sm font-bold uppercase tracking-wider border-2 border-black transition-all outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2 focus:ring-offset-offwhite";
  const variants = {
    primary: "bg-black text-white hover:bg-orange hover:text-black hover:shadow-brutal active:translate-y-1 active:shadow-none",
    secondary: "bg-white text-black hover:bg-gray-100 hover:shadow-brutal active:translate-y-1 active:shadow-none"
  };

  return (
    <button 
      onClick={onClick}
      className={`${baseStyle} ${variants[variant]}`}
    >
      {children}
    </button>
  );
}